import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative z-20 bg-navy-800 text-white mt-24" data-testid="footer">
      <div className="max-w-6xl mx-auto px-6 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="inline-flex items-center bg-white rounded-xl px-4 py-2.5 mb-4">
            <img src="/logo.png" alt="my Property Pune" className="h-9 w-auto" />
          </div>
          <p className="text-white/60 max-w-md leading-relaxed">
            Pune's trusted platform to buy and rent flats, houses and commercial
            spaces — with verified listings and detailed project information.
          </p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4">Explore</h4>
          <ul className="space-y-2 text-white/60">
            <li><Link to="/properties?listing_type=Buy" className="hover:text-brand-400">Buy Property</Link></li>
            <li><Link to="/properties?listing_type=Rent" className="hover:text-brand-400">Rent Property</Link></li>
            <li><Link to="/services" className="hover:text-brand-400">Services</Link></li>
            <li><Link to="/gallery" className="hover:text-brand-400">Gallery</Link></li>
            <li><Link to="/about" className="hover:text-brand-400">About</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4">Contact</h4>
          <ul className="space-y-3 text-white/60 text-sm">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-brand-400" /> Keshavnagar, Mundhwa, Pune-36</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-brand-400" /> +91 9767617770</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-brand-400" /> hello@mypropertypune.in</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-white/40 text-sm">
        © {new Date().getFullYear()} my Property Pune. All rights reserved.
      </div>
    </footer>
  );
}
